import React, { useEffect, useRef, useState } from "react";
import Popper from "@mui/material/Popper";
import Notification from "../assets/images/notification-bell-icon.svg";
import { useGetNotificationListingMutation } from "../store/commonSlice";
import { useAppSelector } from "../store/store";
import { NotificationType } from "../interfaces/notifications";
import { DateFormatter } from "../functions/commons";
import { DATE_FORMAT7 } from "../constants/stringConstants";
import "../css/notifications.css";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
interface PopOverTypes {}

export default function SimplePopperNotification(props: PopOverTypes) {
  const [notifications, setNotifications] = useState<Array<NotificationType>>([]);
  const { user } = useAppSelector((state) => state["user"]);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [getNotificationListing] = useGetNotificationListingMutation();
  const ref = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    getNotificationDataFromDb();

    document.body.addEventListener("click", (e) => {
      let target = e.target as HTMLElement;
      if (target?.id === "itemId") {
      } else {
        onBodyClick(e);
      }
    });
    return () => {
      document.body.removeEventListener("click", (e) => onBodyClick(e));
    };
  }, []);

  const onBodyClick = (event: globalThis.MouseEvent) => {
    if (ref.current?.contains(event.target as Node)) {
      return;
    }
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const getNotificationDataFromDb = async () => {
    const whereObj = encodeURIComponent(`
{
  "order": "createdAt DESC",
 "limit" : "10",
 "offset" : "1",
  "where": {
    "candidates.candidateId":{"eq":"${user?.id}"}
  }
}
`);

    const payload = {
      obj: whereObj,
    };

    getNotificationListing(payload)
      .unwrap()
      .then((notiArray: Array<NotificationType>) => {
        // console.log({ notiArray });
        setNotifications(notiArray);
      });
  };

  const onTapNotificationItem = (item: NotificationType) => {
    // console.log({ notificationItem: item });
    switch (item?.notificationType) {
      case "JOBMATCHED":
        // navigate("/jobs/job-description", {
        //   state: {
        //     companyId: item.companyJob.company.id,
        //     companyJobId: item.companyJobId,
        //     jobMatchPercentage: item?.percentage,
        //   },
        // })
        break;
      case "CHAT":
        navigate("/chats", {
          state: {
            fromNotification: true,
            chatSessionId: item?.extras?.notificationTypeId,
            companyId: item?.extras?.fromUserId,
          },
        });
        break;

      default:
        return null;
    }
  };

  const notificationItem = (item: NotificationType, index: number) => {
    // console.log({ notiItem: item });
    return (
      <div
        id="itemId"
        className="popOver_container"
        style={{
          borderBottom: index + 1 === notifications.length ? "" : "1px solid lightgrey",
          cursor: "pointer",
        }}
        onClick={() => onTapNotificationItem(item)}
      >
        <div className="popOver_content_container">
          <img src={Notification} style={{ width: "15px", height: "15px" }} />
          <div className="popOver_content_text_sec">
            <text>
              {item.notificationType == "TEST"
                ? "Validate your skill"
                : item.extras.chatType == "INTERVIEW"
                ? "Interview Invite"
                : item.extras.chatType == "CHAT"
                ? "New message recieved"
                : item.notificationType == "JOBMATCHED"
                ? `You've got a matching job`
                : ""}
            </text>
            <text>
              {item.notificationType == "TEST"
                ? `${item.content}`
                : item.extras.chatType == "INTERVIEW"
                ? `From ${item.extras.companyName}`
                : item.extras.chatType == "CHAT"
                ? `From ${item.extras.companyName}`
                : item.notificationType == "JOBMATCHED"
                ? `${item.content}`
                : ""}
            </text>
          </div>
        </div>
        <div className="popOver_date_sec">
          <text>{DateFormatter(item.createdAt, DATE_FORMAT7)}</text>
        </div>
      </div>
    );
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  return (
    <div ref={ref}>
      <span onClick={handleClick}>
        <img
          src={Notification}
          className="navbar_routes_item_icon"
          style={{ marginRight: "25px" }}
        />
      </span>

      <Popper id={id} open={open} anchorEl={anchorEl}>
        <div className="scroller_container toggler_container_boxStyle">
          {!isEmpty(notifications) ? (
            notifications.map((item: NotificationType, index) => notificationItem(item, index))
          ) : (
            <div className="notification_sec_emptyStyle">
              <text style={{ fontSize: 17, fontWeight: 600 }}>No Notifications Found</text>
            </div>
          )}
        </div>
      </Popper>
    </div>
  );
}
